import type { MouseEventHandler } from "react";
import type { TWithDataComponent } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const CAT_MEDICAL_CARD_ARTICLE_CLASS =
  "w-full rounded-sys-sm border border-component-card-base p-4 shadow-sm shadow-sys-outline-dark";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TCatMedicalCardProps = TWithDataComponent & {
  allergies: string;
  medicalConditions: string;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const CAT_MEDICAL_CARD_DEFAULTS = {
  "data-component": "CatMedicalCard",
} as const;
